module.exports = __webpack_public_path__ + "img/img-117.489f1442.png";